import Vue from 'vue'
import Vuex from 'vuex'

import VuexORM from '@vuex-orm/core'
import GraphQL from './orm/GraphQL'

import dashboard from './modules/dashboard'
import me from './modules/me'
import params from './modules/params'
import reportList from './modules/report.list'
import studentList from './modules/student.list'
import user from './modules/user'

Vue.use(Vuex)
Vue.config.debug = process.env.NODE_ENV === 'development'
Vue.config.devtools = process.env.NODE_ENV === 'development'


// Create new instance of Database.
const database = new VuexORM.Database()

// Register all models in the 'models' folder
const req = require.context('./models/', 
    true, 
    /.js$/)
req.keys().forEach(key => {
    database.register(req(key).default)
})

VuexORM.use(GraphQL, { database })

export default new Vuex.Store({
    modules: {
        dashboard,
        me,
        params,
        reportList,
        studentList,
        user
    },
    plugins: [VuexORM.install(database)],
    strict: true
})
